/** EOD REVIEW/PREVIEW SERVICES * EOD REVIEW/PREVIEW SERVICES * EOD REVIEW/PREVIEW SERVICES */

// CREATE new EOD Review/Preview
async function createNewEod(uId, token, today, eod) {
  // returns true if create is successful, or throws error.

  // API call
  const newEod = { ...eod };
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify({'eod': newEod}),
  });
  const responseData = await response.json();
  console.log('*** EOD Services >> createNewEod() response ***', response, responseData);

  // "err handling"
  if (!response.ok) { 
    // console.log(responseData);
    throw new Error(response.message || 'Failed to create new EOD Review / Preview');
  }

  return responseData;
}

// READ One EOD Review/Preview
async function getOneEod(uId, token, today) {
  // returns an EOD object, or null

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}/eod.json?auth=${token}`);

  // error handling
  if (!response.ok) {
    throw new Error(response.message || "Failed to get today's EOD Review/Preview");
  }

  // return the data
  return response.json();
}


// UPDATE One EOD Review/Preview
async function updateOneEod(uId, token, today, eod) {
  // returns true if update is successful, or throws error.

  // API call
  const updatedEod = { ...eod };
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify({'eod': updatedEod}),
  });
  // get the response
  const responseData = await response.json();
  if (!response.ok) {
    // console.log(responseData);
    throw new Error(response.message || 'Failed to update EOD Review/Preview');
  } else {
    return responseData;
  }
}


// DELETE One EOD Review/Preview - tbd



export { createNewEod, getOneEod, updateOneEod };
